import _isEmpty from 'lodash/isEmpty';

import { multiCaseGet } from 'libs/format';

export function locationCanUploadMenu(gmbLocation) {
  return multiCaseGet(gmbLocation, 'metadata.canHaveFoodMenus', false);
}

export function locationCanUploadServices(gmbLocation) {
  return multiCaseGet(gmbLocation, 'metadata.canModifyServiceList', false);
}

export function getPrimaryCategory(gmbLocation) {
  return (
    multiCaseGet(gmbLocation, 'primaryCategory.name', null) ||
    multiCaseGet(gmbLocation, 'categories.primaryCategory.name', null) ||
    null
  );
}

export function isRestaurantCategory(gmbLocation) {
  const category = getPrimaryCategory(gmbLocation);

  if (!_isEmpty(category)) {
    const patterns = ['restaurant', 'food'];
    return patterns.some((pattern) => category.toLowerCase().includes(pattern));
  }

  return false;
}

export function isBeautyCategory(gmbLocation) {
  const category = getPrimaryCategory(gmbLocation);

  if (!_isEmpty(category)) {
    const patterns = ['salon', 'spa', 'barber'];
    return patterns.some((pattern) => category.toLowerCase().includes(pattern));
  }

  return false;
}
